import { render, staticRenderFns } from "./coreStrengths.vue?vue&type=template&id=2733940e&scoped=true"
import script from "./coreStrengths.vue?vue&type=script&lang=js"
export * from "./coreStrengths.vue?vue&type=script&lang=js"
import style0 from "./coreStrengths.vue?vue&type=style&index=0&id=2733940e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733940e",
  null
  
)

export default component.exports